import {observer} from 'mobx-react'
import CONTENT from '../stores/Content'
import Picture from '../components/Picture'
// https://aclaes.com/responsive-background-images-with-srcset-and-sizes/

class Slide extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      src: '',
      ready: false
    }
  }

  componentDidMount() {
    this.img.addEventListener('load', this.loadImage)
  }

  componentWillUnmount() {
    this.img.removeEventListener('load', this.loadImage, false)
  }

  loadImage = () => {
    this.update()
  }

  update() {
    let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
    if (this.src !== src) {
      this.setState({
        src: src,
        ready: true
      })
    }
  }

  render() {

    const src = this.img ? this.img.currentSrc : ''

    const css = {
      backgroundImage: `url(${this.state.src})`,
      opacity: this.state.ready && this.props.ready ? this.props.isActive ? 1 : 0 : 0
    }

    return (
      <div className={`slide fs`} style={css} >
        <Picture src={this.props.src} className="none" innerRef={el => this.img = el} />
      </div>
    )
  }
}

class Gallery extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      slideIndex: 0,
      ready: false
    }

    this.interval = null
  }

  componentDidMount() {
    this.timer()

    setTimeout(() => {
      this.setState({
        ready: true
      })
    }, 1500)
  }

  timer() {
    this.interval = setTimeout(() => {
      clearTimeout(this.interval)
      this.nextSlide()
    }, 4000)
  }

  nextSlide() {

    if (CONTENT.holding.gallery.length > 1) {
      const index = this.state.slideIndex
      const ok = index < CONTENT.holding.gallery.length - 1
      this.setState({
        slideIndex: ok ? index + 1 : 0
      })
      this.timer()
    }
  }

  handleClick = e => {
    e.stopPropagation()
    this.nextSlide()
  }

  render() {

    return (
      <div className="gallery pabs fs" onClick={this.handleClick}>
        {CONTENT.holding ? CONTENT.holding.gallery.map(({fields}, i) => {
          const isActive = this.state.slideIndex === i;
          return (
            <Slide src={fields.file.url} ready={this.state.ready} isActive={isActive} key={`slide-${i}`} />
          )
        }) : null}
      </div>

    )
  }
}

export default observer(Gallery)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Gallery.js